import { Suspense, lazy } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const Index = lazy(() => import("./pages/Index"));
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const ChildrensProgram = lazy(() => import("./pages/ChildrensProgramOverview"));
const ArtSpeak = lazy(() => import("./pages/ArtSpeak"));
const ArtSpeakCanvasToCarpet = lazy(() => import("./pages/ArtSpeakCanvasToCarpet"));
const Partners = lazy(() => import("./pages/Partners"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const Camp = lazy(() => import("./pages/Camp"));
const CampSchedule = lazy(() => import("./pages/CampSchedule"));
const CampGallery = lazy(() => import("./pages/CampGallery"));
const CampRegistration = lazy(() => import("./pages/CampRegistration"));
const Events = lazy(() => import("./pages/Events"));
const EventDetail = lazy(() => import("./pages/EventDetail"));
const EventPresent = lazy(() => import("./pages/EventPresent"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/childrens-program" element={<ChildrensProgram />} />
            <Route path="/artspeak" element={<ArtSpeak />} />
            <Route path="/artspeak/canvas-to-carpet" element={<ArtSpeakCanvasToCarpet />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/camp" element={<Camp />} />
            <Route path="/camp/schedule" element={<CampSchedule />} />
            <Route path="/camp/gallery" element={<CampGallery />} />
            <Route path="/camp/registration" element={<CampRegistration />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:slug" element={<EventDetail />} />
            <Route path="/events/:slug/present" element={<EventPresent />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
